export const bodyParams = (lang) => {
    return {
        Dataset: "on",
        Lang: lang,
        SearchType: "proximity",
        Latitude: 43.2827,
        Longitude: -79.1207,
        Distance: 5000,
        Search: "match",
        MatchMode: "all",
        PageIndex: 0,
        PageSize: 1000,
        FullRecord: true,
        Fields: "ApplicationProcess,TaxonomyTerm,TaxonomyTerms,TaxonomyCodes,Eligibility,FeeStructureSource,OfficialName,PhysicalCity,UniqueIDPriorSystem,Categories,DisabilitiesAccess,LanguagesOffered,LanguagesOfferedList",
        ExtCategory: ""
    };
};
export const pageCategory = [{
        page: 'employment-ontario-apprenticeship-offices',
        category: 'FEATS - Apprenticeship Offices'
    }, {
        page: 'prepare-apprenticeship',
        category: 'FEATS - OYAP'
    }, {
        page: 'better-jobs-ontario',
        category: 'FEATS - Employment Services including Better Jobs Ontario'
    }, {
        page: 'adult-learning-literacy-and-basic-skills',
        category: 'FEATS - Literacy and Basic Skills'
    }, {
        page: 'adult-learning-ontario-high-school-diploma',
        category: 'FEATS - Adult High School Credit Program'
    }, {
        page: 'canada-ontario-job-grant',
        category: 'FEATS - Canada Ontario Job Grant'
    }
];
